export const ID_ALL_AGE_GROUPS = Number.MAX_SAFE_INTEGER - 1;
export const SEARCH_TYPE_RECURRING = 'Recurring';
export const SEARCH_TYPE_ONETIME = 'OneTime';
export const SEARCH_TYPE_CLOSED = 'Closed';
